import React from "react";
import { NavBar } from "../components/navBar";
import { Board } from "../components/board";
import './screenOverRideStyles/affirmationBoard.css'
import SearchIcon from '@material-ui/icons/Search';
// import { SearchBar } from "../components/searchBar";

// AIzaSyBz0I-hOrx0YgHaH8lzDq2nUL2aAqlHbIU

export const AffirmationBoard = () => {
  return (
    <>
      <NavBar />
      <form id = 'search__form' method = 'get' title = 'Search Form' action='https://cse.google.com/cse/publicurl'>
      <div>
    <input type='text' id='q' name='q' title='Search this site' alt='Search Text' maxlength='256' target='_blank'/>
    <input type='hidden' id='cx' name='cx' value='e9fac64e9ab6c7ee6' />
   <input type='image' id='searchSubmit' name='submit' src={SearchIcon} alt='Go' title='Submit Search Query' target='_blank'/>
    </div>
</form>
      <Board />
    </>
  );
};
